import { createUseStyles } from "react-jss";

export const useStyles = () => {
  return createUseStyles({
    appContainer: {
      display: "flex",
      backgroundColor: "#F8F8F8",
      height: "100vh",
      gap: "8px",
    },
    pagesContainer: {
      flex: 1,
      padding: "24px 16px 0px 16px",
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
    },
  })();
};
